module.exports = __webpack_public_path__ + "static/media/import_check_id.90639f63.xlsx";